/** RouteFallback — hiển thị trong khi chunk route lazy đang tải (Suspense fallback). */
export function RouteFallback() {
  return (
    <p className="gp-route-fallback" role="status" aria-live="polite">
      Đang tải…
    </p>
  );
}
